import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import {
  RawFoodBenefitsRoot,
  Wrapper,
  Description,
  BenefitsCircle,
  DottedCircle,
  BenefitList,
  MobileBubble,
  DesktopBubble,
  IconCircle,
} from './RawFoodBenefits.styles'
import Trans from 'next-translate/Trans'

type RawFoodBenefitsOwnProps = ComponentProps<typeof RawFoodBenefitsRoot>
export type RawFoodBenefitsProps = RawFoodBenefitsOwnProps & {}

type Benefits = {
  name: string
  icon: IconName
}

const BENEFITS: Benefits[] = [
  { name: 'why-we-feed-raw:benefits.digestion', icon: 'smile-beam' },
  { name: 'why-we-feed-raw:benefits.weight', icon: 'weight' },
  { name: 'why-we-feed-raw:benefits.teeth', icon: 'shield-check' },
  { name: 'why-we-feed-raw:benefits.skin', icon: 'star' },
  { name: 'why-we-feed-raw:benefits.allergies', icon: 'cell' },
  { name: 'why-we-feed-raw:benefits.stools', icon: 'stool' },
  { name: 'why-we-feed-raw:benefits.excitement', icon: 'heart' },
  { name: 'why-we-feed-raw:benefits.immune', icon: 'dna' },
]

export const RawFoodBenefits = (_props: RawFoodBenefitsProps) => {
  const { t } = useTranslation()

  return (
    <RawFoodBenefitsRoot id="#why-we-feed-raw-1">
      <Wrapper>
        <BenefitsCircle>
          <MobileBubble src="assets/wwfr-bubble-mobile.svg" alt="" />
          <DesktopBubble src="assets/wwfr-bubble-desktop.svg" alt="" />
          <DottedCircle />

          <Description>
            <Text
              size={{ '@initial': 'h3', '@bp2': 'h1' }}
              as="h2"
              weight="bold"
              color="accent-black"
              align="center"
            >
              {t('why-we-feed-raw:benefits.title')}
            </Text>
            <div>
              <Text size="headline" color="accent-black" align="center">
                {t('why-we-feed-raw:benefits.description-1')}
              </Text>
              <br />
              <Text size="headline" color="accent-black" align="center">
                <Trans
                  i18nKey="why-we-feed-raw:benefits.description-2"
                  components={{ strong: <strong /> }}
                />
              </Text>
              <br />
              <Text size="headline" color="accent-black" align="center">
                {t('why-we-feed-raw:benefits.description-3')}
              </Text>
            </div>
          </Description>

          <BenefitList>
            {BENEFITS.map(({ name, icon }: Benefits, index) => {
              return (
                <Stack as="li" key={index} direction="column" alignItems="center">
                  <IconCircle>
                    <Icon name={icon} color="accent-black" size="5" />
                  </IconCircle>
                  <Text size="headline" weight="bold" color="accent-black" align="center">
                    {t(name)}
                  </Text>
                </Stack>
              )
            })}
          </BenefitList>
        </BenefitsCircle>
      </Wrapper>
    </RawFoodBenefitsRoot>
  )
}

RawFoodBenefits.displayName = 'RawFoodBenefits'
